import React, { Component } from "react";
import {
  Doctor01,
  Doctor02,
  Doctor03,
  Doctor04,
  Specialities01,
  Specialities02,
  Specialities03,
  Specialities04,
} from "./img";
import { Link } from "react-router-dom";
import axios from "axios";

import { getMensajes, getCookie } from "../functions.js";

import Loader from "../Loader";
class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapseID: "collapse1",
      direccion: "",
      ubicacion: "",
      tipoAcc: "Comprar",
      rolINNOVA2: "",
    };
  }

  componentDidMount = async () => {
    this.setState({ isExecuting: true });
    var DocIdentidadAsesor = getCookie("ciUsuarioINNOVA2");
    var rolINNOVA2 = getCookie("rolINNOVA2");

    console.log("hello", rolINNOVA2);

    var tipoAcc = "Comprar";
    if (DocIdentidadAsesor) {
      if (DocIdentidadAsesor != "null" && rolINNOVA2 === "Vendedor") {
        tipoAcc = "Vender";
      }
    }

    this.setState({ ...this.state, tipoAcc: tipoAcc, rolINNOVA2: rolINNOVA2 });

    var respMensajes = await getMensajes();

    this.setState({
      ...this.state,
      direccion: respMensajes.direccion,
      ubicacion: respMensajes.ubicacion,
      isExecuting: false,
    });
  };

  render() {
    return (
      <div className="main-wrapper">
        {/* Home Banner */}
        <Loader idLoading={this.state.isExecuting} />

        {/* Planes */}
        <section className="specialities" style={{ minHeight: 450 }}>
          <div className="container">
            <div className="section-title text-center">
              <h2>Elija una Opcion</h2>
            </div>
            <div className="row justify-content-center">
              {this.state.rolINNOVA2 === "Consultorio" ? (
                <div className="col-12 col-md-12 col-lg-12">
                  <div className="specialities-col">
                    <div className="card">
                      <Link
                        to={
                          this.state.rolINNOVA2 === "Consultorio"
                            ? "/reservation"
                            : "/login"
                        }
                        className="booking-doc-img "
                      >
                        <button
                          type="button"
                          className="btn btn-primary btn-block"
                          style={{ minWidth: "80px", padding: "2rem" }}
                        >
                          <h2 className="text-white">Agendar Citas</h2>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div className="col-12 col-md-12 col-lg-12">
                    <div className="specialities-col">
                      <div className="card">
                        <Link
                          to={
                            this.state.rolINNOVA2 === "Consultorio"
                              ? "/reservation"
                              : "/login"
                          }
                          className="booking-doc-img "
                        >
                          <button
                            type="button"
                            className="btn btn-primary btn-block"
                            style={{ minWidth: "80px", padding: "2rem" }}
                          >
                            <h2 className="text-white">Agendar Citas</h2>
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                  
                </>
              )}
            </div>
          </div>
        </section>
        {/* /Specialities */}

        {/* /News Letter */}
        {/* Address OLD
        <section className="address-section">
          <div className="container">
            
          </div>
        </section>
         /Address */}
      </div>
    );
  }
}
export default Home;
